var SelectWithSearchModule = /** @class */ (function () {
    function SelectWithSearchModule() {
    }
    return SelectWithSearchModule;
}());
export { SelectWithSearchModule };
